export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Translations.json?hash=a099762cad7f00d667f04b6d482118e0";